import { PAPER_SIZES, PRINT_FORMATS } from '@/app/printing/constants.js'
import i18n from '@/i18n/i18n'

/** @typedef {import('@/types/printing.model').PrintFormat} PrintFormat */

export const ICON_NAMES = {
  externalLink: 'externalLink',
  arrows: 'arrows',
}

export default {
  /**
   * @returns {PrintFormat[]}
   */
  forLabels() {
    return this.getAll().filter(format => format.id !== PRINT_FORMATS.A4_FULL_PAGE)
  },

  /**
   * @returns {PrintFormat[]}
   */
  forPackingSlips() {
    return this.getAll().filter(format => format.id === PRINT_FORMATS.A4_FULL_PAGE)
  },

  /**
   * @returns {PrintFormat[]}
   */
  forPickingLists() {
    return this.getAll().filter(format => format.id === PRINT_FORMATS.A4_FULL_PAGE)
  },

  /**
   * @returns {PrintFormat[]}
   */
  forCustomsDocs() {
    const allowedFormats = [PRINT_FORMATS.A4_FULL_PAGE, PRINT_FORMATS.A6_FULL_PAGE]

    return this.getAll()
      .filter(format => allowedFormats.indexOf(format.id) !== -1)
      .sort((a, b) => allowedFormats.indexOf(a.id) - allowedFormats.indexOf(b.id))
  },

  /**
   * @returns {PrintFormat[]}
   */
  getAll() {
    return [
      {
        id: PRINT_FORMATS.A4_TOP_LEFT,
        startAt: 0,
        size: PAPER_SIZES.A4,
        iconName: ICON_NAMES.externalLink,
        iconRotation: '270',
        label: i18n.t('Top left'),
        helpText: i18n.t('The first document will be printed at the top left corner of the page.'),
      },
      {
        id: PRINT_FORMATS.A4_TOP_RIGHT,
        startAt: 1,
        size: PAPER_SIZES.A4,
        iconName: ICON_NAMES.externalLink,
        label: i18n.t('Top right'),
        helpText: i18n.t('The first document will be printed at the top right corner of the page.'),
      },
      {
        id: PRINT_FORMATS.A4_BOTTOM_LEFT,
        startAt: 2,
        size: PAPER_SIZES.A4,
        iconName: ICON_NAMES.externalLink,
        iconRotation: '180',
        label: i18n.t('Bottom left'),
        helpText: i18n.t('The first document will be printed at the bottom left corner of the page.'),
      },
      {
        id: PRINT_FORMATS.A4_BOTTOM_RIGHT,
        startAt: 3,
        size: PAPER_SIZES.A4,
        iconName: ICON_NAMES.externalLink,
        iconRotation: '90',
        label: i18n.t('Bottom right'),
        helpText: i18n.t('The first document will be printed at the bottom right corner of the page.'),
      },
      {
        id: PRINT_FORMATS.A6_FULL_PAGE,
        startAt: 0,
        size: PAPER_SIZES.A6,
        iconName: ICON_NAMES.arrows,
        label: i18n.t('Full page'),
        helpText: i18n.t('Each printed document will take up an entire page.'),
      },
      {
        id: PRINT_FORMATS.A4_FULL_PAGE,
        startAt: 0,
        size: PAPER_SIZES.A4,
        iconName: ICON_NAMES.arrows,
        label: i18n.t('Full page'),
        helpText: i18n.t('Each printed document will take up an entire page.'),
      },
    ]
  },

  /**
   * @param {PrintFormat[]} formatList
   * @returns {string[]}
   */
  getSizes(formatList) {
    return [...new Set(formatList.map(format => format.size))]
  },
}
